import GoogleMapReact from "google-map-react";
import React from "react";

import { MapMarkerIcon } from "../../icons/mapMarker";
import { LA_CENTER } from "../../utils/googleMap";
import { environmentConfig } from "@src/appV2/environment";

// FIXME: Automatically disabled during ESLint config update
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function AddressViewMap(props: any) {
  const { location = {} } = props;
  const googleMapApi = environmentConfig.REACT_APP_GOOGLE_MAP_API;
  return (
    <GoogleMapReact
      bootstrapURLKeys={{ key: googleMapApi, libraries: "places" }}
      defaultCenter={LA_CENTER}
      zoom={17}
      center={location}
    >
      <MapMarkerIcon {...location} />
    </GoogleMapReact>
  );
}
